<template>
  <div class="Bgc-white">
    <Header />
    <div v-bind:class="{ contentContacto: isActive }" > 
      <div class="container contacto">
        <div class="row justify-content-center">
          <div class="col-lg-10 col-12 mb-3">
            <p class="title">{{$t('language.posadasCorporate.administracionUsuarios.adminUsuarios')}}</p>
          </div>
          <informacionPersonal></informacionPersonal>

          <div class="col-lg-10 col-12 mb-3" >
            <ul class="PC-menutabs PC-menutabs--cols2 mb-3">
              <li v-bind:class="{'PC-menutabs--active':tabActive == 1}" v-if="!noMoreUsers"
                @click="[usuariosRegistrados = true, politicasViaje = false]"
                v-on:click.prevent="tabActive=1">
                <a href="#">{{$t('language.posadasCorporate.administracionUsuarios.usuRegistrados')}}</a>
              </li>
              <li v-bind:class="{'PC-menutabs--active':tabActive == 2}"
                @click="[usuariosRegistrados = false, politicasViaje = true]"
                v-on:click.prevent="tabActive=2">
                <a href="#">{{$t('language.posadasCorporate.administracionUsuarios.polViaje')}}</a>
              </li>
            </ul>

          </div>

          <tablaUsuariosRegistrados v-if="usuariosRegistrados"></tablaUsuariosRegistrados>
          <politicasViaje v-if="politicasViaje"></politicasViaje>

        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import * as GlobalFunctions from '../../utils/GlobalFunctions';
  import Header from '../generales/Header';
  import informacionPersonal from './informacionPersonal/InformacionPersonal'
  import tablaUsuariosRegistrados from './usuariosRegistrados/tablaUsuariosRegistrados'
  import politicasViaje from './usuariosRegistrados/politicasViaje'
  import Footer from '../generales/Footer';
  import SecureLS from "secure-ls";

  export default {
    name: 'AdministracionUsuarios',
    components: {
      Header,
      informacionPersonal,
      tablaUsuariosRegistrados,
      politicasViaje,
      Footer,
    },
    methods: {
           nu001(userType) {
          switch(userType) {
           
           case "AGENTE":
              this.noMoreUsers = true
              this.isActive = false
              this.tabActive = 2
              this.politicasViaje  = true
            break;
           
           case "ADMIN": 
              this.noMoreUsers = false
              this.isActive = true
            break;

            case "SUPER_ADMIN": 
             // Un usuario tipo super admin puede generar usuarios tipo administrador.
             // Esta regla va en match con la regla BR_AU_NU002
              this.noMoreUsers = false
              this.isActive = true

            break;
           
           default:
            break;
            
          }
      },
    },
    data() {
      return {
        isActive: true,
        noMoreUsers: false,
        tabActive: 1,
        usuariosRegistrados: true,
        politicasViaje: false,
        ls: new SecureLS({ encodingType: "aes" }),
      }
    },
    created() {
      if (!GlobalFunctions.validIfGenericUser()) {
        let userType = this.ls.get('Profile').data.userType
        this.nu001(userType)  // Reglas BR_AU_NU001
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/config.scss';
  @import '../../assets/scss/views/v_tablaUsuariosRegistrados.scss';
  .datos {
    i {
      font-size: 18px;
    }
    .navi {
      float: right;
    }
    .editarDatos {
      font-size: $font-size-base;
      color: #0c5458;
      float: right;
    }
  }
  .campos {
    border-bottom: 1px solid $colorBase5;
    &:last-child {
      border-bottom: none;
    }
    .datos {
      padding-bottom: 24px;
    }
    .tituloDatos {
      margin: 0;
      color: $grayBrownish;
      font-size: $font-size-large;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }
    .camposActive {
      color: #0c5458;
      font-weight: 500;
    }
    .tituloDatosEditar {
      margin: 0;
      color: #006900;
      font-weight: 500;
      padding-top: 24px;
      padding-bottom: 24px;
    }
    .cardsInfo {
      background-color: #d1ecf1;
      .nota {
        font-size: $font-size-base;
        color: $grayShadeDark;
      }
      .notaAzul {
        font-size: $font-size-base;
        color: $colorBase2;
        font-weight: 500;
      }
    }
  }
</style>